import React, { useState, useEffect } from 'react';
import { withStyles, makeStyles } from '@mui/styles';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { Container } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Checkbox from '@mui/material/Checkbox';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import { userService, adminService } from '../../services';
import AddViewGroupParticipantsDialog from '../../sharedComponents/GroupDialog/addViewGroupParticipantsDialog';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import FormHelperText from '@mui/material/FormHelperText';
import HeadShot from '../../sharedComponents/profilePhoto/HeadShot';
import HTMLEditor from '../../sharedComponents/HTMLEditor/HTMLEditor';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    notesHeader: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(1.5),
    },
    dialogHeight: {
        padding: theme.spacing(2, 0) + '!important',
    },
    ErrorName: {
        color: 'red',
    },
    formLabel: {
        color: theme.palette.primary.main,
        fontWeight: 500,
    },
    userLabel: {
        paddingLeft: '10px',
    },
    addButtonTop: {
        position: 'relative',
        top: theme.spacing(-4),
        paddingRight: theme.spacing(1)
    },
    progress: {
        marginLeft: '50%',

    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    dialogTabPanel: {
        '& > div': {
            padding: 0
        }
    },
    addButton: {
        cursor: "pointer",
        //marginTop: '7',
        backgroundColor: theme.palette.mode === 'dark'? theme.palette.secondary.main : theme.palette.primary.main,
        borderRadius: '4px',
        //padding: '6px 8px',
        //marginLeft: '5px',
        fontSize: '1rem',
        color: '#fff',
        //width: 'fit-content',
        marginBottom: '5px',
        alignSelf: "center",
        '&:hover': {
            color: '#fff',
            backgroundColor: theme.palette.mode === 'dark'? theme.palette.secondary.main : theme.palette.primary.main,
        },
        '&:focus': {
            color: '#fff',
            backgroundColor: theme.palette.mode === 'dark'? theme.palette.secondary.main : theme.palette.primary.main,
        },
        '& svg': {
            marginRight: '5px',
            width: '20px',
            height: '20px'
        },
    },
    saveButton: {
        cursor: "pointer",
        color: '#fff',
        backgroundColor: theme.palette.mode === 'dark'? theme.palette.secondary.main : theme.palette.primary.main,
    }
}));

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
        backgroundColor: theme.palette.mode === 'dark'? theme.palette.background.default : theme.palette.primary.main,
        color: '#fff'
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography className="font500" variant="subtitle1" noWrap>{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        // padding: '25px 16px',
        //padding: '0px 0px',
        width: '700px',
        [theme.breakpoints.down(281)]: {
            width: '218px',
        },
        [theme.breakpoints.between(281, 322)]: {
            width: '258px',
        },
        [theme.breakpoints.between(321, 556)]: {
            width: '275px'
        },
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ExpansionPanelSegment = (props) => {
    const classes = useStyles();
    const [isExpanded, setIsExpanded] = useState(props.expanded);

    useEffect(() => {
        setIsExpanded(props.expanded);
    }, [props.expanded]);

    return (
        <Accordion className={classes.expansionPanel}
            expanded={isExpanded}
            onChange={() => setIsExpanded(!isExpanded)}
        >
            <AccordionSummary
                className={classes.expansionPanelSummary}
                expandIcon={<ExpandMoreIcon />}
            >
                <Typography display="inline" className={classes.filterTitle} color="primary">
                    {props.title}</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.expansionPanelDetails}>
                {isExpanded && <React.Fragment>{props.children}</React.Fragment>}
            </AccordionDetails>
        </Accordion>
    );
};

const AddShowcaseParticipantsDialog = (props) => {
    const classes = useStyles();
    const [selectedUsers, setSelectedUsers] = useState( props.data ? props.data.assignedUsers : []);
    const [selectedFrontOfficeUsers, setSelectedFrontOfficeUsers] = useState([]);
    const [value, setValue] = React.useState('0');
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const [frontOfficeUsers, setfrontOfficeUsers] = useState([]);
    const [openParticipantDialog, toggleParticipantDialog] = useState(false);
    const [showcaseTitle, setShowcaseTitle] = useState(props.data ? props.data.title : null);
    const [showcaseStartDate, setShowcaseStartDate] = useState(props.data ? props.data.startDate :moment());
    const [showcaseEndDate, setShowcaseEndDate] = useState(props.data ? props.data.endDate : moment());
    const [showcaseMessage, setShowcaseMessage] = useState(props.data ? props.data.message : null);

    const [errorTitleText, setTitleErrorText] = useState();
    const [errorFrontUserText, setFrontUserText] = useState();
    const [existFrontUser, setExistFrontUserText] = useState([]);
    const [selectedDetailedProfiles, setSelectedDetailedProfiles] = useState([]);
    const [errorMessageText, setMessageErrorText] = useState();
    //const [startMinDate, setStartMinDate] = useState( (props.data && new Date(props.data.startDate) < moment().toDate()) ? props.startDate: moment().subtract(2,'day').toDate());

    useEffect(() => {
        userService.getAllFrontOfficeUser()
            .then(res => {
                if (res.length > 0) {
                    res.unshift({"id":0,"firstName" : "Select", "lastName" : "All" ,"userName" : "all"})
                    setfrontOfficeUsers(res);
                }
            })
            .catch(err => {
                console.error(err);
            })
           
            if(props.selectedProfiles && props.selectedProfiles.length > 0)
            {
                adminService.getProfilesByUserIds({userIds: props.selectedProfiles})
                .then(res => {
                    setSelectedDetailedProfiles(res);
                })
                .catch(err => {
                    console.error(err);
                })
            }
    }, [])

    useEffect(() => {
        // props.data ?
        // ( 
        let existUser = frontOfficeUsers.filter(user => props.data  && props.data.assignedUsers.includes(user.userName));
        if (existUser.length == frontOfficeUsers.filter((u) => u.id != 0).length) {
            existUser.unshift({ "id": 0, "firstName": "Select", "lastName": "All", "userName": "all" });
        }
        setExistFrontUserText(existUser);
        //  : [];        
    }, [frontOfficeUsers])

    const handleClose = (e, success) => {
        props.handleCloseClick(success);
    };

    const handleCloseClick = (isSuccess) => {
        // if (!!isSuccess) {
        //     setShowError(true);
        //     setMessage("Memo sent to selected users.")
        //     setSeverity("success")
        // }
        toggleParticipantDialog(false);
        //setCurrentMemoId(null);
    }

    const handleSaveClick = (obj) => {
        // if (!!isSuccess) {
        //     setShowError(true);
        //     setMessage("Memo sent to selected users.")
        //     setSeverity("success")
        // }
        toggleParticipantDialog(false);
        setSelectedUsers(obj.userIds);
        //setCurrentMemoId(null);
    }

    const errorTitleCheck = (value) => {
        const charactersExp = new RegExp('[^a-zA-Z0-9_@&.,)( \-]');
        setShowcaseTitle(value);
        if (!value)
            setTitleErrorText("Name is required.");
        else if (value.match(charactersExp)) {
            setTitleErrorText("Please enter valid name.");
        } else {
            setTitleErrorText();
        }
    }

    const errorFrontUserCheck = (value) => {
        console.log(value)
        if (value === 0 && existFrontUser.length === 0)
            setFrontUserText("Front office user is required.");
         else {
            setFrontUserText();
        }
    }

    const handleTitleChange = (event) => {
        setShowcaseTitle(event.target.value);
        errorTitleCheck(event.target.value);
    };

    const handleSaveShowcaseClick = () => {
        errorTitleCheck(showcaseTitle);
        errorFrontUserCheck(selectedFrontOfficeUsers.length>0 ? selectedFrontOfficeUsers.length : selectedUsers.length);
        checkMessage(showcaseMessage);
        const assignedfrontUsers = selectedFrontOfficeUsers.length > 0 ? selectedFrontOfficeUsers : existFrontUser.filter(a => a.id !== 0).map(a => a.userName);
        if ( (assignedfrontUsers.length > 0 || selectedUsers.length > 0) && showcaseTitle && !errorTitleText && !errorFrontUserText && showcaseMessage){
            props.handleSaveShowcaseClick({ title: showcaseTitle, startDate: showcaseStartDate, endDate: showcaseEndDate, assignedUsers: [...assignedfrontUsers, ...selectedUsers],message:showcaseMessage })
        }        
    }

    const onAddClick = () => {
        toggleParticipantDialog(true);
    };
    const handleChange = (newValue) => {
        if (newValue && newValue.filter(v => { if (v.id === 0) return v; }).length === 0) {
            setSelectedFrontOfficeUsers([]);
            setSelectedFrontOfficeUsers(newValue.map(a => a.userName));
            errorFrontUserCheck(newValue.length);
            setExistFrontUserText(newValue);
        }
    }
    const handleSelecteAll = (option, selected) => {
        if (option.id === 0) {
            var users = frontOfficeUsers.filter(a => { if (a.id !== 0) return a; }).map(a => a.userName);
            if (selected === false) {
                setExistFrontUserText([...frontOfficeUsers]);
                setSelectedFrontOfficeUsers([]);
                setSelectedFrontOfficeUsers(users);
                errorFrontUserCheck(users.length);
            }
            else {
                setSelectedFrontOfficeUsers([]);
                errorFrontUserCheck(0);
                setExistFrontUserText([]);
                var selUsers = selectedUsers.filter((u) => !users.includes(u));
                setSelectedUsers(selUsers);
            }
        }
        else {
            if (selected === true) {
                {
                    var selUsers = selectedUsers.filter((u) => u != option.userName);
                    setSelectedUsers(selUsers);
                }
            }
        }
    }

    const onChange = (event) => {
            setShowcaseMessage(event.editor.getData());
            checkMessage(event.editor.getData());
    }

    const checkMessage = (value)=>{
        let content = value?value.trim():'';
        if (content.length !==0) {
            setMessageErrorText();
        }
        else
            setMessageErrorText('Email Content is required.')
    }
    const renderUsersList = () => {

        return selectedDetailedProfiles && selectedDetailedProfiles.map((user, index) => {
            return <ListItem>
                <ListItemAvatar>
                    <HeadShot userName={user.userName} profilePhoto={user.personalDetails.profilePhoto} />
                </ListItemAvatar>
                <ListItemText primary={`${user.personalDetails.fullName.firstName} ${user.personalDetails.fullName.lastName}`}/>

            </ListItem>
        })

    }

    return (
        <div>
            <Dialog maxWidth={true} onClose={handleClose} aria-labelledby="customized-dialog-title" open={props.open} fullScreen={false}>
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    {props.action} Showcase
                </DialogTitle>
                <DialogContent dividers className={classes.dialogHeight}>
                    <Container>
                        <Grid container alignItems='center' spacing={1}>
                            <Grid size={{ xs: 12, sm: 12 }}>
                                <TextField id="DataField" variant="outlined"
                                    label={<Typography variant="body2">Title</Typography>}
                                    size="small" fullWidth
                                    value={showcaseTitle}
                                    name="Title"
                                    // required={true}
                                    onChange={handleTitleChange}
                                //error={errorNameText}
                                />
                                {errorTitleText && <FormHelperText className={classes.ErrorName} >{errorTitleText}</FormHelperText>}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                {/* {startMinDate.toString()} */}
                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                    <DatePicker
                                        label={"Start Date"}
                                        minDate={(props.data && new Date(props.data.startDate) < moment().toDate()) ? props.data.startDate: moment()}
                                        disabled={(props.data && new Date(props.data.startDate) < moment().toDate())}
                                        value={showcaseStartDate}
                                        format="MM-DD-YYYY"
                                        onChange={(value) => {
                                            setShowcaseStartDate(value);
                                            setShowcaseEndDate(moment(value).add(1,"months"))
                                        }}
                                    />
                                </LocalizationProvider>
                                {/* {errorNameText && <FormHelperText className={classes.ErrorName} >{errorNameText}</FormHelperText>} */}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                    <DatePicker
                                        label={"End Date"}
                                        minDate={showcaseStartDate}
                                        value={showcaseEndDate}
                                        format="MM-DD-YYYY"
                                        onChange={setShowcaseEndDate}
                                    />
                                </LocalizationProvider>
                                {/* {errorNameText && <FormHelperText className={classes.ErrorName} >{errorNameText}</FormHelperText>} */}
                            </Grid>
                            {selectedDetailedProfiles && selectedDetailedProfiles.length > 0 &&
                                <Grid size={{ xs: 12, sm: 12 }}>
                                <div style={{border: '0.5px dotted orange', padding: '1rem', display: 'flex', flexDirection: 'column', overflowY: 'auto', height: '150px'}}>
                                    <div style={{fontWeight: 'bold', paddingBottom: '5px'}}>You have Selected {selectedDetailedProfiles.length} profiles for this showcase.</div>
                                        {/* <div style={{padding: '0 5px', lineHeight: '1.5'}}>
                                            {props.selectedProfiles && props.selectedProfiles.map((usersName) => (
                                                <div>{usersName}</div>
                                            ))}
                                        </div>*/}
                                        {renderUsersList()}
                                </div> 
                                
                            </Grid>
                            }
                            
                            <Grid size={{ xs: 12, sm: 9 }}>
                                <Autocomplete
                                    value={existFrontUser.filter(a => a.id !== 0)}
                                    multiple
                                    limitTags={2}
                                    id="checkboxes-tags-demo"
                                    options={frontOfficeUsers}
                                    onChange={(event, newValue) => {
                                        handleChange(newValue);
                                    }}
                                    disableCloseOnSelect
                                    getOptionLabel={(option) => option.firstName + " " + option.lastName}
                                    renderOption={(props, option, { selected }) => {
                                        const selectAllIndex = existFrontUser.findIndex(
                                            a => a.id === 0
                                        );
                                        if (selectAllIndex > -1) {
                                            selected = true;
                                        }
                                        return (
                                            <li {...props} key={option.userName || option.id}>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                    onChange={() => handleSelecteAll(option, selected)}
                                                />
                                                {option.firstName + " " + option.lastName}
                                            </li>
                                        );
                                    }
                                    }
                                    // style={{ width: 500 }}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="outlined" label="Front Office Users" placeholder="Select Front Office Users" />
                                    )}
                                />
                                {errorFrontUserText && <FormHelperText className={classes.ErrorName} >{errorFrontUserText}</FormHelperText>}
                            </Grid>

                            <Grid size={{ xs: 12, sm: 3 }}>
                                <IconButton className={classes.addButton} onClick={onAddClick}>Group Users</IconButton>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}>
                                <HTMLEditor
                                    id="message" name="message"
                                    data={showcaseMessage}
                                    onChange={onChange}
                                    error={undefined}
                                />
                                {errorMessageText && <FormHelperText className={classes.ErrorName} >{errorMessageText}</FormHelperText>}

                            </Grid>
                        </Grid>
                    </Container>
                </DialogContent>
                <DialogActions>
                    <Button className={classes.saveButton} variant='contained' onClick={handleSaveShowcaseClick}>Save</Button>
                </DialogActions>
            </Dialog>
            {openParticipantDialog &&
                <AddViewGroupParticipantsDialog
                    groupList={props.groupList}
                    open={openParticipantDialog}
                    handleCloseClick={handleCloseClick}
                    userIds={selectedUsers}
                    handleSaveClick={handleSaveClick}
                    showOnlyFOGroup = {true}
                />}
        </div >
    );
}

export default AddShowcaseParticipantsDialog;

